// src/components/Table/TableHeader.tsx

import React from 'react';
import { TableHead } from './styles';
import { TableRow } from './TableRow';
import { TableCell } from './TableCell';
import { Column, ActionColumn } from '../../types/table';
import StyledText from '../StyledComponents/StyledText';
import { CorporateTheme } from '../../utils/themes';

interface TableHeaderProps<T> {
    columns: Array<Column<T> | ActionColumn<T>>;
    showActions?: boolean;
}

export const TableHeader = <T,>({
    columns,
    showActions = false
}: TableHeaderProps<T>) => {
    return (
        <TableHead>
            <TableRow>
                {columns.map((column) => {
                    if (column.key === 'actions' && !showActions) return null;

                    return (
                        <TableCell
                            key={column.key as string}
                            isHeader
                            width={column.width}
                            align={column.align}
                        >
                            <StyledText textColor={CorporateTheme.colors.headerColor} fontSize='13px' fontWeight={600}>{column.title}</StyledText>
                        </TableCell>
                    );
                })}
            </TableRow>
        </TableHead>
    );
};